import React from "react";
import { useNavigate } from "react-router-dom";
import { Grid, Typography } from "@mui/material";
import Facebook from "assets/images/Facebook.svg";
import Instagram from "assets/images/Instagram.svg";
import Twitter from "assets/images/Twitter.svg";
import Linkedin from "assets/images/Linkedin.svg";
import appStore from "assets/images/app-store-apple-f1f919205b.svg"
import playStore from "assets/images/app-store-google-4d63c31a3e.svg"

function Footer() {
  const navigate = useNavigate();
  const onClickPolicy = () =>{
    navigate('/privacy-policy')
  }
  const onClickTerms = () =>{
    navigate('/termsandconditions')
  }
  return (
   
      <Grid
        container
        justifyContent="space-evenly"
        alignItems="start"
        direction="row"
        className="footer"
      >
        <Grid item md={2} xs={12} className="header">
          <Typography className="footerHeading">Company</Typography>
          <li>Home</li>
          <li>About</li>
          <li>Safety</li>
        </Grid>
        <Grid item md={2} xs={12} className="header">
          <Typography className="footerHeading">Services</Typography>
          <li>Oneway</li>
          <li>Rental</li>
          <li>Outstation</li>
          <li>Airport Transfer</li>
        </Grid>
        <Grid item md={2} xs={12}
        justifyContent='center'
        className="header marginTop45">
          <li onClick={onClickPolicy}>Privacy</li>
          <li onClick={onClickTerms}>Terms & Conditions</li>
        </Grid>
        <Grid item md={2} xs={12} direction="column" justifyContent="flex-start">
          <Grid item className="header">
            <Typography className="footerHeading">Follow us</Typography>
          </Grid>
            <Grid item className="cursor">
              <img src={Facebook}  className="marginRight6" alt="facebook" />
              <img src={Twitter}   className="marginRight6" alt="twitter" />
              <img src={Instagram}  className="marginRight6" alt="instagram" />
              <img src={Linkedin}   className="marginRight6"alt="linkedIn" />
            </Grid>
           
        </Grid>
        <Grid item md={2} xs={12} className="list marginTop25 cursor">
         <li><img src={playStore} alt="playStore"/></li>
         <li><img src={appStore} alt="applestore"/></li>
        </Grid>
      </Grid>
  );
}

export default Footer;
